module.exports = __webpack_public_path__ + "static/media/img_mausoleo.d183631d.jpg";